export class PlusMinusChange {
    constructor(optionalOptions = {}) {
        this._inputs = document.querySelectorAll('.plus-minus--button');

        if (!this._inputs) {
            this.destructor();
            return true;
        }

        let number = 0,
            max = 999,
            min = 0;

        let inputObj, spanObj;

        for (let i = 0; i < this._inputs.length; ++i) {
            let input = this._inputs[i];
            input.addEventListener('click', (event) => {
                event.preventDefault();

                inputObj = input.parentElement.querySelector('input[type="number"]')
                spanObj = input.parentElement.querySelector('[data-type="number"]')

                number = Number(inputObj.value) || 0;
                if (input.dataset.type === 'minus') {
                    number = number - 1;
                    if (number < min) {
                        number = min;
                    }
                }

                if (input.dataset.type === 'plus') {
                    number = number + 1;
                    if (number > max) {
                        number = max;
                    }
                }

                spanObj.innerText = number;
                inputObj.setAttribute('value', number);
            });
        }
    }

    destructor() {
        this._inputs = null;
    }
}

export default new PlusMinusChange();